<template v-if="history">
  <div>
    <p>
      <span v-if="history.date">{{ new Date(history.date) | dateFormat('DD.MM.YYYY') }}</span>
      <span>{{ history.status }}</span>
      <span>{{ history.userFio }}</span>
    </p>
    <template v-if="history.comment">
      <p>{{ $t('Комментарии') }}: {{ history.comment }}</p>
    </template>
  </div>
</template>

<script>

export default {
  props: {
    history: Object
  }
}
</script>

<style scoped>

</style>
